import React from "react";

function validateParams({ field, entity }) {
  return !(
    !entity ||
    !field ||
    !field.hasOwnProperty("fieldName") ||
    !entity.hasOwnProperty(field.fieldName)
  );
}

export default function DisplayConditionListRenderer({ field, entity, entities, validation }) {
  if (!validateParams({ field, entity, entities, validation })) {
    return null;
  }
  const conditions = entity[field.fieldName];
  const renderedConditions = conditions.map(condition => {
    switch (condition.class) {
      case "stringComparison":
        return (
          <div key={condition.type}>
            {condition.type}: {condition.value.join(",")}
          </div>
        );
      default:
        console.log("no error status");
        return null;
    }
  });

  return <div>{renderedConditions}</div>;
}
